export const MEMBER_PROFILES_MERGED_ACTION = 'member_profiles_merged';

type ActionDetailsRecord = Record<string, unknown>;

export type MergeProfileDetailRow = {
  label: string;
  value: string;
};

const parseActionDetails = (raw: unknown): ActionDetailsRecord | null => {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return null;
    try {
      const parsed = JSON.parse(trimmed);
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed as ActionDetailsRecord;
      }
      return null;
    } catch {
      return null;
    }
  }
  if (typeof raw === 'object' && !Array.isArray(raw)) {
    return raw as ActionDetailsRecord;
  }
  return null;
};

const pickString = (details: ActionDetailsRecord, keys: string[]): string => {
  for (const key of keys) {
    const value = details[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return '';
};

export const buildMergeProfileDetailRows = (
  raw: unknown
): {
  profileRows: MergeProfileDetailRow[];
  reassignedTables: Record<string, number> | null;
} => {
  const details = parseActionDetails(raw);
  if (!details) {
    return { profileRows: [], reassignedTables: null };
  }

  const profileRows: MergeProfileDetailRow[] = [
    {
      label: 'Old profile email',
      value: pickString(details, ['old_profile_email', 'source_member_email']),
    },
    {
      label: 'Old profile ID',
      value: pickString(details, ['old_profile_id']),
    },
    {
      label: 'Primary profile',
      value: pickString(details, ['primary_profile_name']),
    },
    {
      label: 'Primary profile ID',
      value: pickString(details, ['primary_profile_id']),
    },
  ].filter((row) => row.value);

  const reassignedRaw = details.reassigned_tables;
  const reassignedTables =
    reassignedRaw &&
    typeof reassignedRaw === 'object' &&
    !Array.isArray(reassignedRaw)
      ? (reassignedRaw as Record<string, number>)
      : null;

  return { profileRows, reassignedTables };
};
